import { Navigate, useLocation, useMatch } from 'react-router-dom'
import { isLoggedIn } from '../../utils'

export default function PrivateRoute(props) {
  // eslint-disable-next-line no-unused-vars
  const {path, component: Component, ...rest } = props
  const location = useLocation()
  const match = useMatch(path)
  return isLoggedIn() ? (<Component location={location} match={match} {...props} />) : (<Navigate to="/login" />)
}
